import React, { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { Dropdown } from "react-bootstrap";
// import { PiDownloadSimpleDuotone } from "react-icons/pi";
import { BsThreeDotsVertical } from "react-icons/bs";
import { CiCirclePlus } from "react-icons/ci";
import { RiDeleteBinLine } from "react-icons/ri";
import { FaRegEdit } from "react-icons/fa";
import { IoShareSocialOutline } from "react-icons/io5";
import { BsFileEarmarkPlus } from "react-icons/bs";
import SVG from "react-inlinesvg";
import moment from "moment";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { WhatsappIcon, WhatsappShareButton } from "react-share";
import { IoIosCopy } from "react-icons/io";
import copy from "clipboard-copy";
import { SweetAlert, showConfirmDialog } from "../../../helpers/helper";
import styles from "./index.module.css";
import { get, post } from "../../../components/api";
import GoogleMapsLoader from "../../../components/GoogleMapsLoader";
import GoogleMapComponent from "../../../components/MapComponent";
import ModalPopup from "../../../components/ModalPopup";
import RouteBtn from "../../../assets/images/tms/routebtn.svg";
import locationIcon from "../../../assets/images/tms/location.svg";
import directionIcon from "../../../assets/images/tms/direction.svg";
import leftArrow from "../../../assets/images/tms/left-arrow.svg";
import rightArrow from "../../../assets/images/tms/right-arrow.svg";
import calendarIcon from "../../../assets/images/tms/calendar.png";
import { Card, CardBody } from "react-bootstrap";
import TMSDataTablePagination from "../../../components/TMSTable";
import { ReactSelect } from "../../../components/ReactSelect";
import Loading from "../../../components/Loading";

const RoutesPage = () => {
  const navigat = useNavigate();
  const [routes, setRoutes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [routesData, setRoutesData] = useState([]);
  const [selectedRoute, setSelectedRoute] = useState("");
  const [selectLocation, setSelectedLocation] = useState([]);
  const [selectedLocIndex, setSelectedLocIndex] = useState(null);
  const [selectView, setSelectView] = useState("map-view");
  const [startDate, setStart] = useState(moment().startOf("day").toDate());
  const [endDate, setEnd] = useState(moment().toDate());
  const [showModalPopup, setShowModalPopup] = useState(false);
  const [shareUrl] = useState("http://tinyurl.com");

  const getRouteList = async () => {
    const routeList = await get("/admin/tms/route-list");
    if (routeList.status == 200) {
      let options = routeList.data.map((data) => {
        return { _id: data._id, name: data.routeName };
      });
      setRoutesData(options);
    } else {
      setRoutesData([]);
    }
  };

  const getAllRoutes = async (filter) => {
    setIsLoading(true);
    const getVehicles = await post("/admin/tms/routes", {
      search: filter,
    });
    if (getVehicles.status == 200) {
      setRoutes(getVehicles.data);
      setIsLoading(false);
    } else {
      setRoutes([]);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getRouteList();
    getAllRoutes();
  }, []);

  const handleChange = (name, value) => {
    if (selectView === "map-view") {
      let filter = {
        route: value?._id,
      };
      getAllRoutes(filter);
    }
    setSelectedRoute(value);
  };

  const initialSettings = {
    startDate: startDate,
    endDate: endDate,
    timePicker: true,
    timePicker24Hour: false,
    alwaysShowCalendars: true,
    maxDate: moment().toDate(),
    maxTime: moment().format("HH:mm"),
    locale: {
      format: "DD/MM/YYYY h:mm A",
    },
    opens: "left",
    ranges: {
      Today: [moment().startOf("day"), moment()],
      Yesterday: [
        moment().subtract(1, "days").startOf("day"),
        moment().subtract(1, "days").endOf("day"),
      ],
      "Last 7 Days": [moment().subtract(6, "days").startOf("day"), moment()],
      "Last 15 Days": [moment().subtract(14, "days").startOf("day"), moment()],
      "This Month": [
        moment().startOf("month").startOf("day"),
        moment().endOf("month").endOf("day"),
      ],
      "Last Month": [
        moment().subtract(1, "month").startOf("month").startOf("day"),
        moment().subtract(1, "month").endOf("month").endOf("day"),
      ],
    },
  };

  const handleApplyDate = (event, picker) => {
    const selectedStart = picker.startDate;
    const selectedEnd = picker.endDate;
    if (selectedEnd.isBefore(selectedStart.clone().add(1, "months"))) {
      const startDateTime = moment(selectedStart).format("DD/MM/YYYY HH:mm");
      const endDateTime = moment(selectedEnd).format("DD/MM/YYYY HH:mm");
      setStart(startDateTime);
      setEnd(endDateTime);
    } else {
      SweetAlert(
        "Please select a date range within one month from the start date.",
        true
      );
    }
  };

  const openDeleteDialog = async (id) => {
    const confirmed = await showConfirmDialog(
      "Delete!",
      "Are you sure you want to delete route?"
    );
    if (confirmed) {
      try {
        const deleteRoute = await post(`/admin/tms/delete/routes/${id}`);
        if (deleteRoute.status === 200) {
          const data = [...routes];
          const updatedRoutes = data.filter((route) => route._id !== id);
          setRoutes(updatedRoutes);
          SweetAlert("Route delete successfully.", false);
        } else {
          SweetAlert("Unable to delete the route, Try again", true);
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  const changeRoute = (id, index) => {
    const route = routes.find((record) => record._id === id);
    if (route) {
      const pointsArray = route?.routePoints.map((r) => ({
        lat: r.coordinates[0],
        lng: r.coordinates[1],
      }));
      setSelectedLocation(pointsArray);
      setSelectedLocIndex(index);
    }
  };

  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <a
      href=""
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      {children}
      <BsThreeDotsVertical size={"20px"} color="#2A7C7A" />
    </a>
  ));

  CustomToggle.displayName = "CustomToggle";

  const columns = [
    {
      name: "Route Name",
      selector: (row) => row.routeName,
      sortable: true,
    },
    {
      name: "Start Address",
      selector: (row) => {
        return row?.routePoints[0]?.address;
      },
    },
    {
      name: "Distance",
      selector: (row) => {
        return `${row?.routePoints[0]?.distance}KM`;
      },
    },
    {
      name: "End Address",
      selector: (row) => {
        return row?.routePoints[row?.routePoints?.length - 1]?.address;
      },
    },
    {
      cell: (row) => (
        <Dropdown>
          <Dropdown.Toggle
            as={CustomToggle}
            style={{ display: "block", marginBottom: "50px" }}
          />
          <Dropdown.Menu
            size="sm"
            title="Actions"
            className="action-dropdown"
            style={{
              position: "absolute",
              top: "80px", // Adjust height to position it above
              zIndex: 1000,
            }}
          >
            <Dropdown.Item>
              <div
                className="d-flex align-items-center cursor-pointer"
                onClick={() => openDeleteDialog(row._id)}
              >
                <RiDeleteBinLine size={19} />
                <span className="invoice-btn-text">Delete</span>
              </div>
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      ),
      allowoverflow: true,
      button: true,
      width: "56px",
    },
  ];

  // close modal
  const handleCloseModal = () => {
    setShowModalPopup(false);
  };

  const handleShowModal = async () => {
    setShowModalPopup(true);
  };

  const copyToClipboard = () => {
    copy(shareUrl);
    SweetAlert("Link copy successfully.", false);
  };

  const memoizedColumns = useMemo(() => columns, [columns]); // Only if columns are recreated
  const memoizedQueryObj = useMemo(
    () => ({
      route: selectedRoute?._id ? selectedRoute?._id : "",
    }),
    [selectedRoute?._id]
  );

  return (
    <GoogleMapsLoader>
      <div className={`${styles.routes} ${styles.ml5}`}>
        <div className="d-flex justify-content-between mb-2">
          <h5 className={`${styles.title} text-left`}>Routes</h5>
          <div className="d-flex gap-2">
            {selectView === "table-view" && (
              <div style={{ width: "250px" }}>
                <ReactSelect
                  name="selectedRoute"
                  value={selectedRoute}
                  options={routesData}
                  handleOnChange={(name, value) => {
                    handleChange(name, value);
                  }}
                  isSearchable={true}
                  isClearable={true}
                  isLoading={false}
                  noOptionsMessage="Route not availables."
                  placeholder="Select Route"
                />
              </div>
            )}
            <div className="position-relative">
              <img
                src={calendarIcon}
                className={styles.dateIcon}
                alt="Calendar Icon"
              />
              <DateRangePicker
                initialSettings={initialSettings}
                onApply={handleApplyDate}
              >
                <input type="text" className={styles.customInput} readOnly />
              </DateRangePicker>
            </div>
            {/* <Button variant="primary" className={styles.downloadBtn}>
              <PiDownloadSimpleDuotone className="me-2" />
              Route Reports
            </Button>
            <Button variant="primary" className={styles.downloadBtn}>
              <PiDownloadSimpleDuotone className="me-2" />
              Route Budges Report
            </Button> */}
            <Button
              variant="outline-primary"
              className={styles.outlineBtn}
              onClick={() => navigat("/tms/routes/add")}
            >
              <CiCirclePlus size={18} />
              <span className={styles.ml4}>Add</span>
            </Button>
             {selectView === "table-view" && (
            <Button
                variant="outline-primary"
                className={styles.outlineBtn}
                onClick={() => setSelectView("map-view")}
              >
                <span className={styles.ml4}>Show Map View</span>
              </Button>
            )}
            </div>
        </div>
        {/* <div className="text-right">
          {selectView === "table-view" && (
            <Button
              variant="outline-primary"
              className={styles.outlineBtn}
              onClick={() => setSelectView("map-view")}
            >
              <span className={styles.ml4}>Show Map View</span>
            </Button>
          )}
        </div> */}
        {selectView === "table-view" ? (
          <div className="row mt-3">
            <div className="col-md-12 col-lg-12 col-xs-12">
              <div className="custom-datatable">
                <TMSDataTablePagination
                  columns={memoizedColumns}
                  apiUrl={"admin/tms/routes"}
                  queryObj={memoizedQueryObj}
                  isRoute={true}
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="row pl-1 mt-3">
            <div
              className={`col-12 col-md-5 col-lg-5 col-sm-12 ${styles.box} `}
            >
              <div className="row">
                <div
                  className={`${styles.pr0} col-12 col-md-8 col-lg-8 col-sm-12`}
                >
                  <ReactSelect
                    name="selectedRoute"
                    value={selectedRoute}
                    options={routesData}
                    handleOnChange={(name, value) => {
                      handleChange(name, value);
                    }}
                    isSearchable={true}
                    isClearable={true}
                    isLoading={false}
                    noOptionsMessage="Route not availables."
                    placeholder="Select Route"
                  />
                </div>
                <div className="col-12 col-md-4 col-lg-4 col-sm-12 p-0">
                  <button
                    type="button"
                    className={`btn btn-outline-success ${styles.customButton}`}
                    onClick={() => setSelectView("table-view")}
                  >
                    <span className={styles.mr8}>Show List View</span>
                    <SVG src={RouteBtn} width={"15px"} />
                  </button>
                </div>
              </div>
              {isLoading ? (
                <Loading />
              ) : (
                <div className={`mt-4 ${styles.scrollContainer}`}>
                  {!isLoading && routes.length === 0 && (
                    <div>
                      <p>Routes not found</p>
                    </div>
                  )}
                  {routes.length > 0 &&
                    routes.map((route, i) => {
                      return (
                        <div key={`${route._id}_${i}`}>
                          <Card className="mb-3">
                            <CardBody
                              className={`p-0 ${
                                selectedLocIndex === i && "selected-location"
                              }`}
                            >
                              <div
                                className="cursor-pointer p-3"
                                onClick={() => changeRoute(route._id, i)}
                              >
                                <div className="d-flex align-items-center">
                                  <SVG src={locationIcon} />
                                  <p className={styles.routeName}>
                                    {route.routeName}
                                  </p>
                                </div>
                                <div className="d-flex align-items-center justify-content-between mt-4 mb-2">
                                  <div className="d-flex">
                                    <SVG src={directionIcon} />
                                    <div
                                      className={`text-left ml-2 ${styles.mr10}`}
                                    >
                                      <p className={styles.label}>
                                        Start Address
                                      </p>
                                      <p className={styles.value}>
                                        {`${route?.routePoints[0]?.city},${route?.routePoints[0]?.state}`}
                                      </p>
                                    </div>
                                  </div>
                                  <SVG src={leftArrow} width={"70px"} />
                                  <p className={`ml-2 ${styles.mr10}`}>
                                    ({route?.routePoints[0]?.distance}KM)
                                  </p>
                                  <SVG src={rightArrow} width={"70px"} />
                                  <div className="d-flex ml-2">
                                    <SVG src={directionIcon} />
                                    <div className="text-left ml-2">
                                      <p className={styles.label}>
                                        End Address
                                      </p>
                                      <p className={styles.value}>
                                        {`${route?.routePoints[route?.routePoints.length - 1]?.city},${route?.routePoints[route?.routePoints.length - 1]?.state}`}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className={styles.boxBottom}>
                                <div
                                  className="d-flex align-items-center cursor-pointer"
                                  onClick={() =>
                                    navigat(`/tms/routes/edit/${route._id}`)
                                  }
                                >
                                  <FaRegEdit size={19} color="#ffffff" />
                                  <span className={styles.labelText}>Edit</span>
                                </div>
                                <div
                                  className="d-flex align-items-center cursor-pointer"
                                  onClick={() =>
                                    navigat(`/tms/add/trip`, {
                                      state: {
                                        routeData: {
                                          _id: route._id,
                                          name: route.routeName,
                                        },
                                      },
                                    })
                                  }
                                >
                                  <BsFileEarmarkPlus
                                    size={19}
                                    color="#ffffff"
                                  />
                                  <span className={styles.labelText}>
                                    Create a Trip
                                  </span>
                                </div>
                                <div
                                  className="d-flex align-items-center cursor-pointer"
                                  onClick={handleShowModal}
                                >
                                  <IoShareSocialOutline
                                    size={19}
                                    color="#ffffff"
                                  />
                                  <span className={styles.labelText}>
                                    Share
                                  </span>
                                </div>
                                <div
                                  className="d-flex align-items-center cursor-pointer"
                                  onClick={() => openDeleteDialog(route._id)}
                                >
                                  <RiDeleteBinLine size={19} color="#ffffff" />
                                  <span className={styles.labelText}>
                                    Delete
                                  </span>
                                </div>
                              </div>
                            </CardBody>
                          </Card>
                        </div>
                      );
                    })}
                </div>
              )}
            </div>
            <div className="col-12 col-md-7 col-lg-7 col-sm-12">
              <div style={{ borderRadius: "12px", overflow: "hidden" }}>
                <GoogleMapComponent locationsData={selectLocation} />
              </div>
            </div>
          </div>
        )}
      </div>
      {showModalPopup && (
        <ModalPopup
          className="modal"
          show={handleShowModal}
          onHide={handleCloseModal}
          title="Route Share Link"
        >
          <div>
            <h6>Share the following link to view the route</h6>
            <div className="d-flex justify-content-center align-items-center">
              <input
                type="text"
                className="form-control"
                value={shareUrl}
                disabled
              />
              <IoIosCopy
                size={32}
                className="cursor-pointer ml-10"
                onClick={copyToClipboard}
              />
              <WhatsappShareButton
                url={shareUrl}
                className="Demo__some-network__share-button ml-10"
              >
                <WhatsappIcon size={32} />
              </WhatsappShareButton>
            </div>
          </div>
        </ModalPopup>
      )}
    </GoogleMapsLoader>
  );
};

export default RoutesPage;
